
import {
  fetchDrinksBeers,
  fetchDrinksKegs,
  fetchDrinksLiquors,
  fetchDrinksPage,
} from '@/assets/scripts/api'
import { getDrinkIdentity } from '@/assets/scripts/dataObjects/dataPageDrinks'
import { mutations, store } from '@/assets/scripts/store'
import { bestPicFormat } from '@/assets/scripts/utils'
import DetailToPopin from '@/mixins/DetailToPopin'
import PageData from '@/mixins/PageData'

export default {
  name: 'DrinksPage',
  popinContentComponent: 'DetailDrink',
  mixins: [PageData, DetailToPopin],

  async asyncData({ payload }) {
    let apiData
    let drinkCache

    if (payload) {
      ;({ apiData, drinkCache } = payload)
    } else {
      apiData = await fetchDrinksPage()
      drinkCache = {
        beers: await fetchDrinksBeers(),
        kegs: await fetchDrinksKegs(),
        liquors: await fetchDrinksLiquors(),
      }
    }

    return { apiData, drinkCache }
  },

  data() {
    return {
      category: store.drinks.category || 0,
      drinks: mutations.getDrinks().list || [],
      cardComponent: 'span',
    }
  },

  computed: {
    currentCategoryDrinks() {
      return this.drinkCache?.[['beers', 'liquors', 'kegs'][this.category]]
    },
  },

  watch: {
    category(value) {
      this.updateDrinks()
      this.$refs.gridsection.scrollIntoView({ behavior: 'smooth' })
    },
  },

  created() {
    this.bestPicFormat = bestPicFormat
  },

  mounted() {
    this.cardComponent = 'DrinkCardBeer'
    if (!this.drinks.length) {
      this.randomize()
    }
  },

  methods: {
    headerClick(index) {
      this.category = index
    },

    randomize() {
      this.updateDrinks()
    },

    updateDrinks() {
      const randomized = this.currentCategoryDrinks.sort(
        (a, b) => 0.5 - Math.random()
      )
      this.drinks.splice(0)
      this.drinks.push(...randomized.slice(0, 20)) // limit to 20 drinks for performance
      mutations.saveDrinks(
        this.category,
        JSON.parse(JSON.stringify(this.drinks))
      ) // save drinks for page reload
    },

    getPopinData() {
      const isSlugMatching = (slug) => (drink) => drink.slug === slug
      let category = -1
      let popinData = null

      if (
        this.$route.params.popin === undefined ||
        this.$route.params.popin === 'undefined'
      ) {
        /* eslint-disable-next-line */
        console.error(
          'Error generate drink popin for id',
          this.$route.params.popin
        )
        return {}
      }

      while (!popinData && ++category < 3) {
        popinData = this.drinkCache[
          ['beers', 'liquors', 'kegs'][category]
        ].find(isSlugMatching(this.$route.params.popin))
      }

      if (!popinData) {
        return null
      }

      const maskIdentity = this.apiData.headers[category].maskIdentity
      popinData.identity = getDrinkIdentity(popinData, maskIdentity)
      return popinData
    },
  },
}
